export const projects = [
    {
      title: "Gym Management System",
      subtitle: "Laravel",
      description:
        "This is a Gym Management System helps to run some managerial operations of a gym. Some of the functionalies implemented include regestration of users and members , assigning users access control privileges, storing records of equipments, trainers, payments and mode of payments. The system also generates charts and reports on membership,equipments and payments.",
      image: "./welcomepage.png",
      link: "https://github.com/WaltTersly/my-laravel-project.git",
    },
    {
      title: "Data Science",
      subtitle: "Data Science And Machine Learning",
      description:
        "This contains various projets both big and small. The projects contain exercises on the simplest concepts of datascience which are Numpy, Pandas, some expolatory data analysis and along side machine learning concepts like regressions and other classifications. This is a learning project.  ",
      image: "./datascience.jpg",
      link: "https://github.com/WaltTersly/datascience-projects.git",
    },
    {
      title: "Simple Todo App",
      subtitle: "Laravel Framework",
      description:
        "This is a web based application that manages to-do items. it is a laravel Application that is hosted on heroku to create, edit, view and delete tasks as one completes them. One can mark the complete tasks as they complete them and delete them later on",
      image: "./todo.jpg",
      link: "https://pacific-beyond-25788.herokuapp.com",
    },
    {
      title: "Gemvist Ventures LTD",
      subtitle: "Laravel And Vuejs",
      description:
        "This is a project  incorporates concepts of front-end and back-end . It's a website displays details about a car selling company, the various types models and price ranges of cars. This was a joint collaboration with Chief Eng. Victor Allen, his portfolio address https://www.vicallendev.tk/ ",
      image: "./gemvist1.jpg",
      link: "http://my-motorshop-dev.herokuapp.com",
    },
    {
      title: "Tersly's Blog",
      subtitle: "Laravel Framework",
      description:
        "This is a blog website that implements both frontend and backend . One gets to post readings and concepts that users can read. In addition one can search for particular post  which can belong to a certain category and have several tags. It was developed using laravel and has great potential.",
      image: "./take2.png",
      link: "https://blogging-cms.herokuapp.com",
    },
  ];
  
   export const contacts = [
    {
        address: "59281-00200 Nairobi",
        physical: "Nkoroi, Ongata-Rongai, Kajiado",
        email: "chegewalter59@gmail.com",
        phone: "+254727498856,  +254727956653",
    },
   ];

  export const skills = [
    {
        title: "JavaScript",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/javascript/javascript.png",
    },
    {
        title: "Php",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/php/php.png",
    },
    {
        title: "React",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/react/react.png",
    },
    {
        title: "Laravel",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/laravel/laravel.png",
    },
    {
        title: "Python",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/python/python.png",
    },
    {
        title: "Git",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/git/git.png",
    },
    {
        title: "Github",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQmReOyP4NTob1p6pAMjg7nmEzUSZS3e7e4OjNu_zY&s=10",
    },
    {
        title: "Visual-Studio-Code",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/visual-studio-code/visual-studio-code.png",
    },
    {
        title: "Html",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/html/html.png",
    },
    {
        title: "Css",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/css/css.png",
    },
    {
        title: "SQL",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/mysql/mysql.png",
    },
    {
        title: "Data-Science",
        image: "https://thumbs.dreamstime.com/b/data-science-icon-simple-element-organization-collection-filled-templates-infographics-more-172201473.jpg",
    },
    {
        title: "Terminal",
        image: "https://raw.githubusercontent.com/github/explore/80688e429a7d4ef2fca1e82350fe8e3517d3494d/topics/terminal/terminal.png",
    },
    {
        title: "C++",
        image: "https://www.logo.wine/a/logo/C%2B%2B/C%2B%2B-Logo.wine.svg",
    }
  ];


// WEBPACK FOOTER //
// ./src/data.js